<template>
  <v-container>
    <v-row v-if="!faqCategories.length">
      <v-col>
        <v-alert color="info" type="info">
          We’re sorry, there are no FAQs at this time. Please check back later.
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" lg="8">
        <v-row
          v-for="category in faqCategories"
          :key="category.id"
          class="pb-6"
        >
          <v-col>
            <v-row>
              <v-col>
                <v-card
                  :ref="
                    el => {
                      categoryRefs[slugify(category)] = el
                    }
                  "
                  class="mb-1"
                  color="background"
                  rounded="0"
                  variant="flat"
                >
                  <v-card-item class="text-h4 text-center font-weight-light">
                    {{ category.name }}
                  </v-card-item>
                </v-card>
              </v-col>
            </v-row>

            <v-item-group multiple>
              <v-item
                v-for="item in category.faq_items"
                :key="item.id"
                v-slot="{ isSelected, toggle }"
              >
                <v-row dense>
                  <v-col>
                    <SimpleRevealCard
                      :title="item.faq.question_text"
                      :value="isSelected"
                      @toggle="toggle"
                    >
                      <!-- eslint-disable vue/no-v-html -->
                      <div
                        class="text-body-1"
                        v-html="item.faq.answer_body"
                      ></div>
                    </SimpleRevealCard>
                  </v-col>
                </v-row>
              </v-item>
            </v-item-group>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        :style="{ top: `${MENU_BAR_HEIGHT}px` }"
        align-self="start"
        class="d-none d-lg-flex sticky"
        cols="12"
        lg="4"
      >
        <v-card rounded="0" variant="flat" width="100%">
          <v-list lines="one">
            <v-list-subheader class="text-h5 mb-2"
              >Jump to Category</v-list-subheader
            >
            <v-divider />

            <template v-for="category in faqCategories" :key="category.id">
              <v-list-item
                :href="`#${slugify(category)}`"
                @click="scrollToRefKey(categoryRefs, category)"
              >
                <v-list-item-title>{{ category.name }}</v-list-item-title>
              </v-list-item>
              <v-divider />
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, reactive } from 'vue'
import { MENU_BAR_HEIGHT } from '#root/lib/consts'
import { scrollToRefKey, slugify } from '#root/lib/utils'

defineProps({
  faqCategories: {
    required: true,
    type: Array
  },
  value: {
    required: true,
    type: Object
  }
})

const categoryRefs = reactive({})

onMounted(async () => {
  await scrollToRefKey(categoryRefs, undefined, { delay: true })
})
</script>
